<h2 mat-dialog-title class="mat-h2">
  {{ config.title }}
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <mat-label class="mat-subtitle-2">Value</mat-label>
      <mat-form-field appearance="outline" class="text-area">
        <textarea
          class="textarea-popup"
          matInput
          rows="4"
          cols="200"
          [(ngModel)]="testValue"
          required
          [ngModelOptions]="{ standalone: true }"
          required
          formcontrolName="testValue"
          oninput="this.value = this.value.replace(/[^A-Za-z0-9-,.;'&amp;\/().\n\r ]|^ /g,'')"
          >
          {{ testValue }}
        </textarea>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
@if (this.userService?.roleCheck(['Labtech', 'Manager', 'Admin'])) {
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()">UPDATE</button>
  </mat-dialog-actions>
}
